import PageHeader from "../components/PageHeader";
import Stats from "../components/Stats";
import Certifications from "../components/Certifications";
import CTABanner from "../components/CTABanner";
import { motion } from "framer-motion";
import { COMPANY } from "../lib/content";

const milestones = [
  { year: "2008", title: "Founded", body: "BNM Group established in Ankara with its first international trading desk." },
  { year: "2012", title: "Petrochemicals", body: "Dedicated petrochemicals and raw materials desk launched." },
  { year: "2016", title: "Global expansion", body: "Representative presence in Dubai and Almaty to serve MENA and Central Asia." },
  { year: "2020", title: "Industrial & Rail", body: "Industrial machinery and rail infrastructure desks structured for large-scale mandates." },
  { year: "2025", title: "Seven industries", body: "Operating across rail, aviation, petrochemicals, machinery, agriculture, vehicles and telecommunications." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        eyebrow="About BNM Group"
        title="International trading, from Ankara to the world."
        subtitle={COMPANY.description}
        image="https://static.prod-images.emergentagent.com/jobs/992269a5-240d-47a2-94bf-57af67715604/images/107173358a58b4fd951837fe4813b7bcfbd17e66dd1538255a609f5864d5d57d.png"
        testId="about-page-header"
      />

      <section className="py-24 sm:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-px bg-[#F37021]" />
              <span className="text-eyebrow text-[#F37021]">Our Story</span>
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.02] text-[#0A1F3F]"
            >
              Built in Ankara.
              <br />
              Trusted worldwide.
            </motion.h2>
          </div>
          <div className="lg:col-span-7 space-y-6 text-[#0A1F3F] text-lg leading-relaxed">
            <p>
              BNM Group is an international trading and industrial supply
              company headquartered in Ankara, Turkey.
            </p>
            <p className="text-[#4B5668] text-base">
              The company operates across multiple sectors including
              petrochemical products, industrial machinery, transportation
              systems, agricultural commodities, telecommunications
              infrastructure, and global sourcing services.
            </p>
            <p className="text-[#4B5668] text-base">
              With a strong network of international suppliers, manufacturers,
              and logistics partners, BNM Group facilitates reliable and
              efficient trade between global markets.
            </p>
            <div className="pt-4 border-l-2 border-[#F37021] pl-5">
              <div className="text-eyebrow text-[#F37021] mb-2">Our Mission</div>
              <p className="text-[#0A1F3F] text-lg font-display font-bold">
                To connect industries, markets, and opportunities through
                strategic global partnerships.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 sm:py-32 bg-[#F4F5F8]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="mb-16">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-px bg-[#F37021]" />
              <span className="text-eyebrow text-[#F37021]">Milestones</span>
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.02] text-[#0A1F3F]">
              Years in motion.
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-px bg-[#E3E6EC] border border-[#E3E6EC]">
            {milestones.map((m, i) => (
              <motion.div
                key={m.year}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-white p-8"
                data-testid={`milestone-${m.year}`}
              >
                <div className="font-display font-black text-4xl text-[#F37021] tracking-tighter">
                  {m.year}
                </div>
                <div className="mt-4 font-display font-bold text-lg text-[#0A1F3F]">{m.title}</div>
                <div className="mt-2 text-sm text-[#4B5668] leading-relaxed">
                  {m.body}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Stats />
      <Certifications />
      <CTABanner />
    </div>
  );
}
